export const ALL_ORDERS_FILTER = 'ALL_ORDERS';
export const CLAIM_PROPOSALS_FILTER = 'CLAIM_PROPOSALS';

export enum OrderHandlingMode {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}
